const CONFIRMATION_URL =
  process.env.REACT_APP_CONFIRMATION_URL ||
  "https://clientwebsitesuat2.kfintech.com/dit-nps-transaction-confirmation/summary";

const generateUrl = (obj) => {
  const queryParams = new URLSearchParams();
  Object.keys(obj).forEach((key) => {
    queryParams.set(key, encodeURIComponent(btoa(obj[key])));
  });
  return `${CONFIRMATION_URL}?${queryParams.toString()}`;
};

export default generateUrl;
